/**
 * The words on an empty new chat: the greeting and the starter suggestions.
 * They lived on the separate Dashboard start page until 2026-10-06, when that
 * page was folded into the chat itself (one start screen, see
 * pages/tenant/StartRedirect.tsx).
 */

export const CHAT_STARTER_SUGGESTIONS = [
  "Summarise what happened today",
  "Draft a client update email",
  "Help me prep for my next meeting",
  "What should I be focusing on this week?",
];

/** Hour of day to "morning" / "afternoon" / "evening". */
export function timeOfDayGreeting(date: Date = new Date()): "morning" | "afternoon" | "evening" {
  const h = date.getHours();
  if (h < 12) return "morning";
  if (h < 18) return "afternoon";
  return "evening";
}

/** The person's first name, from their name, else the start of their email. */
export function firstName(user: { name?: string | null; email?: string | null } | null | undefined): string {
  if (!user) return "there";
  if (user.name) return user.name.split(/\s+/)[0];
  const emailPrefix = user.email?.split("@")[0] ?? "there";
  return emailPrefix.replace(/[._-]+/g, " ").split(/\s+/)[0] || "there";
}
